import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import swal from "sweetalert";
import MainPagetitle from '../../layouts/MainPagetitle';

import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
import AdminRestrictedDateService from '../../api/services/AdminRestrictedDateService';
import CamperService from '../../api/services/CamperService';

const RestrictedPickupOrReturnList = () => {
    const [Error, setError] = useState('');

    var imageUrl = process.env.REACT_APP_LARAVEL_IMAGE_URL + 'Tripplan/';
    const [UploadedList, setUploadedList] = useState([]);
    const [camper, setCamper] = useState([]);
    const [camperSubscription, setCamperSubscription] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setisloading] = useState(true);
    const recordsPage = 50;
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;
    const records = UploadedList.slice(firstIndex, lastIndex);
    const npage = Math.ceil(UploadedList.length / recordsPage)
    const number = [...Array(npage + 1).keys()].slice(1)
    const navigate = useNavigate();
    function prePage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }
    function changeCPage(id) {
        setCurrentPage(id);
    }
    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }


    const getUploadedList = async () => {

        try {
            let responseData = await AdminRestrictedDateService.index().json()
            setUploadedList(responseData.data)
            let camper = await CamperService.index().json();

            var camperdata = camper.data.filter(function (item) {
                return item.camper_type_id == 1 && item.status == 1
            });
            setCamper(camperdata);
            var responsesubscription = camper.data.filter(function (item) {
                return item.camper_type_id == 2 && item.status == 1
            });
            setCamperSubscription(responsesubscription)
            setisloading(false);
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();

                setError(errorJson.message)
            }
        }
    }
    useEffect(() => {
        if (localStorage.getItem('admintoken')) {

            getUploadedList();

        }
        else {
            navigate('/');
        }

    }, [])
    const handledeletefunction = (id) => {
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this data!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {

                let responseData = await AdminRestrictedDateService.destroy(id).json()
                if (responseData.status === true) {
                    getUploadedList();
                }
                swal("Your Restricted Pickup/Return Date has been deleted successfully!", {
                    icon: "success",
                });
            }
        }).catch(() => {
            swal("Your Restricted Date is safe!");
        });
    }
    return (
        <>
            <MainPagetitle mainTitle="Restricted Pickup/Return Dates" pageTitle={'Restricted Pickup/Return Dates'} parentTitle={'Home'} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <h4 className="heading mb-0"> Restricted Dates</h4>
                                        <div>
                                            <Link to={`/admin/add-restricted/`} className="btn btn-primary btn-sm ms-1">+ Add Restricted Dates</Link> {" "}
                                        </div>
                                    </div>
                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                            <thead>
                                                <tr style={{ textAlign: 'center' }}>
                                                    <th >
                                                        <strong>No.</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Start Date</strong>
                                                    </th>
                                                    <th>
                                                        <strong>End Date</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Affected Rent Vehicles </strong>
                                                    </th>
                                                    <th>
                                                        <strong>Affected Subcription Vehicles </strong>
                                                    </th>

                                                    <th style={{ textAlign: 'left' }}><strong>Action</strong></th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {
                                                    records.map((element, index) => {

                                                        return (
                                                            <tr style={{ textAlign: 'center' }}>
                                                                <td>
                                                                    {index + 1}
                                                                </td>
                                                                <td>
                                                                    {element.startdate}

                                                                </td>
                                                                <td>
                                                                    {element.enddate}
                                                                </td>
                                                                <td style={{ whiteSpace: 'pre-line' }}>

                                                                    {/* {element.camper_title ?
                                                                        camper.length === element.camper_title.length ?
                                                                            "All Vehicles" :
                                                                            element.camper_title.map((title, index) =>
                                                                                index === element.camper_title.length - 1 ? title : title + ", "
                                                                            ).join('')
                                                                        : "_"
                                                                    } */}
                                                                     {
                                                                        element.camper_title && element.camper_title.length > 0
                                                                            ? element.camper_title.length === camper.length
                                                                                ? "All Vehicles"
                                                                                : element.camper_title.map((title, index) =>
                                                                                    index === element.camper_title.length - 1 ? title : title + ", "
                                                                                ).join('')
                                                                            : "_"
                                                                    }
                                                                </td>
                                                                <td style={{ whiteSpace: 'pre-line' }}>

                                                                    {
                                                                        element.campersubscription_title && element.campersubscription_title.length > 0
                                                                            ? element.campersubscription_title.length === camperSubscription.length
                                                                                ? "All Vehicles"
                                                                                : element.campersubscription_title.map((title, index) =>
                                                                                    index === element.campersubscription_title.length - 1 ? title : title + ", "
                                                                                ).join('')
                                                                            : "_"
                                                                    }

                                                                </td>


                                                                <td>
                                                                    <div className="d-flex">
                                                                        <Link
                                                                            to={`/admin/edit-restricted/${element.id}`}
                                                                            className="btn btn-primary shadow btn-xs sharp me-1"
                                                                        >
                                                                            <i className="fas fa-pencil-alt"></i>
                                                                        </Link>
                                                                        <Link className="btn btn-danger shadow btn-xs sharp" onClick={() => handledeletefunction(element.id)}
                                                                        >
                                                                            <i className="fa fa-trash"></i>
                                                                        </Link>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }

                                            </tbody>

                                        </table>
                                        <div className="d-sm-flex text-center justify-content-between align-items-center">
                                            <div className='dataTables_info'>
                                                Showing {lastIndex - recordsPage + 1} to{" "}
                                                {UploadedList.length < lastIndex ? UploadedList.length : lastIndex}
                                                {" "}of {UploadedList.length} entries
                                            </div>
                                            <div
                                                className="dataTables_paginate paging_simple_numbers justify-content-center"
                                                id="example2_paginate"
                                            >
                                                <Link
                                                    className="paginate_button previous disabled"
                                                    to="#"
                                                    onClick={prePage}
                                                >
                                                    <i className="fa-solid fa-angle-left" />
                                                </Link>
                                                <span>
                                                    {number.map((n, i) => (
                                                        <Link className={`paginate_button ${currentPage === n ? 'current' : ''} `} key={i}
                                                            onClick={() => changeCPage(n)}
                                                        >
                                                            {n}

                                                        </Link>
                                                    ))}
                                                </span>
                                                <Link
                                                    className="paginate_button next"
                                                    to="#"
                                                    onClick={nextPage}
                                                >
                                                    <i className="fa-solid fa-angle-right" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {isLoading && <LogoAnimationLoader />}
        </>
    );
};

export default RestrictedPickupOrReturnList;
